/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902018601 — ServiceWait */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { PrimaryButton, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { useTimer } from '../../../../shared/hooks/useTimer';
import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { useGetFile } from '../../hooks/useGetFile';
import { useGetFiscData } from '../../hooks/useGetFiscData';
import { useServiceStore } from '../../hooks/useServiceStore';
import { SERVICE_ROUTES } from '../../service.constants';
import { isReceiptValid } from '../../service.utils';
import styles from './ServiceWait.module.css';

export const ServiceWait = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const vm = useAppStore((s) => s.vm);
    const data = useServiceStore((s) => s.receiptData);
    const setData = useServiceStore((s) => s.setReceiptData);

    const timerValue = data.evadts_waiting;
    const timerHook = useTimer(timerValue);

    const getFileMutation = useGetFile();
    const getFiscDataMutation = useGetFiscData();

    const onMainPage = (): void => {
        navigate(generatePath(SERVICE_ROUTES.main, { id: vm.qr }), {
            replace: true,
        });
    };

    useEffect(() => {
        getFileMutation.mutate(vm.vm_id, {
            onError: () => {
                navigate(generatePath(SERVICE_ROUTES.fail, { id: vm.qr }), {
                    replace: true,
                });
            },
        });

        timerHook.start();

        return () => {
            timerHook.reset();
        };
    }, []);

    useEffect(() => {
        // Early return in case timer is off
        if (timerHook.time <= 0) {
            navigate(generatePath(SERVICE_ROUTES.fail, { id: vm.qr }), {
                replace: true,
            });
            timerHook.reset();
            return;
        }

        // Navigate to Service complete page in case receipt data is valid
        if (isReceiptValid(data)) {
            navigate(generatePath(SERVICE_ROUTES.complete, { id: vm.qr }), {
                replace: true,
            });
            return;
        }

        // Fetch fiscal data until on each timer second (ping it)
        getFiscDataMutation.mutate(vm.vm_id, {
            onSuccess: setData,
            onError: (error) => {
                console.error(
                    {
                        module: 'service',
                        action: 'getFiscData',
                        vmId: vm.vm_id,
                    },
                    error,
                );
            },
        });
    }, [timerHook.time]);

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Request wait')} </ScreenTitle>
            <div className={styles.box}>
                <object className={styles.element} data="/Subtract.png" />
            </div>
            <PrimaryButton onClick={onMainPage}>{t('Main page')}</PrimaryButton>
        </ScreenWrapper>
    );
};
